module.exports = {
  appid: 'a556b4b130a59b10164aa1824c30ebd5',
  client_id: 'bff226aa98eb2e84fb29bf148c0a8bd5129bc105ee638ffd33fc3315b6c705c5'
};
